import React, { Suspense, lazy, useState } from "react";
import SallyLauncher from "./components/SallyLauncher";

const SallyPanel = lazy(() => import("./SallyPanel"));

const SallyWidget = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {!open && (
        <div className="fixed bottom-5 right-5 z-[80]">
          <SallyLauncher onClick={() => setOpen(true)} />
        </div>
      )}
      {open && (
        <Suspense
          fallback={
            <div className="fixed bottom-5 right-5 z-[80] flex h-16 w-16 items-center justify-center rounded-full bg-secondary text-white shadow-xl">
              <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/30 border-t-white" />
            </div>
          }
        >
          <SallyPanel onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
};

export default SallyWidget;
